/**
 * Phase I.2 — PWA BYOK (Bring Your Own Key) store.
 *
 * Mirrors the Android EncryptedSharedPreferences model: device-local
 * storage of the user's own Gemini / OpenAI / Anthropic key, never sent
 * to our server. When set, chat + image gen requests go DIRECT from the
 * browser to the provider (CORS-enabled APIs) — our server is bypassed.
 *
 * Security model: same as Android. The key sits in localStorage which is
 * page-scoped and TLS-protected in transit. Anyone with physical device
 * access could read it — that's true on Android too. Industry standard
 * for client-side AI key handling.
 */
const KEY_PREFIX = "aura_byok_";
const PROVIDER_KEY = "aura_byok_provider";

export const BYOK_PROVIDERS = ["gemini", "openai", "anthropic"];
export const BYOK_LABELS = {
  gemini: "Google Gemini",
  openai: "OpenAI",
  anthropic: "Anthropic",
};

export function getByokProvider() {
  return localStorage.getItem(PROVIDER_KEY) || "gemini";
}

export function setByokProvider(provider) {
  localStorage.setItem(PROVIDER_KEY, provider);
}

export function getByokKey(provider = getByokProvider()) {
  return localStorage.getItem(`${KEY_PREFIX}${provider}`) || "";
}

export function setByokKey(provider, key) {
  localStorage.setItem(`${KEY_PREFIX}${provider}`, (key || "").trim());
}

export function clearByokKey(provider) {
  localStorage.removeItem(`${KEY_PREFIX}${provider}`);
}

/** Returns true if ANY provider has a stored key. Drives BYOK eligibility. */
export function hasAnyByokKey() {
  return BYOK_PROVIDERS.some((p) => (localStorage.getItem(`${KEY_PREFIX}${p}`) || "").trim() !== "");
}

/** Returns the current effective key for the currently-selected provider,
 *  or empty string if none set. The router uses this to decide whether to
 *  route DIRECT to the provider or fall back to our /api/chat. */
export function activeByokKey() {
  return getByokKey(getByokProvider());
}
